import type { Network } from "../types";

export const pinterest: Network = {
  name: "Pinterest",
  shareUrl: "https://pinterest.com/pin/create/button/?url=[u]",
  args: {
    title: "&description=[t]",
    image: "&media=[i]",
  },
  icon: "/media/images/facebook-social-auth.svg",
  color: "#BD081C",
};
